export default {
  en: {
    again: "Don't remember",
    know: 'Remember',
    knowForSure: "Definitely know, don't show again",
  },
  ru: {
    again: 'Не помню',
    know: 'Помню',
    knowForSure: 'Знаю, больше не показывать',
  },
};
